import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  field: {
    [theme.breakpoints.up('mobile')]: {
      width: 300,
    },
    '& input': {
      fontSize: 22,
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.up('mobile')]: {
        fontSize: 28,
      },
    },
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  iconButton: {
    color: theme.palette.colors.gray,
    height: '1.5em',
    width: '1.5em',
    cursor: 'pointer',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/PercentInputField/useStyles.js